import config from './config.js';

export class Powerup {
    constructor() {
        this.x = Math.random() * config.gameWidth;
        this.y = Math.random() * config.gameHeight;
        this.radius = 35; // Adjusted for the new style
        this.duration = 4000; // 5 seconds duration
        this.speedBoost = 1.5; // 50% speed increase
        this.type = 'speed'; // Specify the powerup type
    }

    update() {
        // Add any animation logic here if needed
    }
}
